import { createFileRoute } from '@tanstack/react-router';
import { MediaLibraryPage } from '../../features/content';

export const Route = createFileRoute('/admin/content/media')({ component: MediaLibraryPage });
